import { FeeDescription } from '@efex-services/rate/types';
import rateSvc from '../services/rate/rateSvc';
import { DECIMALS_TO_SHOW } from './formater';
import executeWithCancellation from './promiseUtils';

/* eslint-disable import/prefer-default-export */
export const getExchangeResult = async ({
  amount,
  reverse,
  rateUuid,
  enterpriseId,
  requestFee = false,
  onChangeResult,
  setCancelFunction,
}: {
  amount: string;
  reverse: boolean;
  rateUuid: string;
  enterpriseId: string;
  requestFee?: boolean;
  onChangeResult: ({
    amount,
    feeDescription,
  }: {
    amount: number;
    feeDescription?: FeeDescription;
  }) => void;
  setCancelFunction: (cancel: () => void) => void;
}) => {
  const rateResult = await rateSvc.getExchangeResult({
    rateUuid,
    amount: parseFloat(amount.replaceAll(',', '')).toString(),
    reverse,
    enterpriseId,
    requestFee,
  });

  setCancelFunction(rateResult.cancel);

  const result = await executeWithCancellation(() => rateResult.request);

  if (!result) return;

  onChangeResult({
    amount: Number(result.result.toFixed(DECIMALS_TO_SHOW)),
    feeDescription: result.fee_description || undefined,
  });
};
